import Box from "@material-ui/core/Box";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Dispatch, StoreState } from "../../../store";
import {
  ElectricityFilter,
  GasFilter,
  GlassFiberFilter,
  HeatingFilter,
  ProductType,
  Tariff,
} from "../../../types/index";
import Autocomplete from "../../Autocomplete";

interface Props {
  productTypeFilter:
    | ElectricityFilter
    | GasFilter
    | HeatingFilter
    | GlassFiberFilter;
  onChange: (productFamilies: string[]) => void;
  productType: ProductType;
  disabled?: boolean;
}

const getProductFamiliesDistinct = (tariffTypes: Tariff[]) => {
  return tariffTypes.reduce<string[]>((acc, tariff) => {
    const productFamily = tariff.productFamily;
    if (productFamily && acc.indexOf(productFamily) === -1) {
      return acc.concat([productFamily]);
    } else {
      return acc;
    }
  }, []);
};

const ProductFamilyFilter: React.FC<Props> = ({
  productTypeFilter,
  onChange,
  productType,
  disabled,
}: Props) => {
  const dispatch = useDispatch<Dispatch>();

  const getProductFamiliesOptions = (state: StoreState) => {
    if ((productTypeFilter as any).supplyTypeFilter) {
      return state.supplyTypesMappedToProductFamilies[productType][
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (productTypeFilter as ElectricityFilter | GasFilter).supplyTypeFilter!
      ];
    } else {
      switch (productType) {
        case ProductType.ELECTRICITY:
          return getProductFamiliesDistinct(state.tariffTypesElectricity.data);
        case ProductType.GAS:
          return getProductFamiliesDistinct(state.tariffTypesGas.data);
        case ProductType.HEATING:
          return getProductFamiliesDistinct(state.tariffTypesHeating.data);
        case ProductType.GLASS_FIBER:
          return getProductFamiliesDistinct(state.tariffTypesGlassFiber.data);
      }
    }
  };

  useEffect(() => {
    switch (productType) {
      case ProductType.ELECTRICITY:
        dispatch.tariffTypesElectricity.fetchTariffTypesElectricity(null);
        break;
      case ProductType.GAS:
        dispatch.tariffTypesGas.fetchTariffTypesGas(null);
        break;
      case ProductType.HEATING:
        dispatch.tariffTypesHeating.fetchTariffTypesHeating(null);
        break;
      case ProductType.GLASS_FIBER:
        dispatch.tariffTypesGlassFiber.fetchTariffTypesGlassFiber(null);
        break;
    }
  }, [dispatch, productType]);

  const productFamiliesOptions = useSelector((state: StoreState) =>
    getProductFamiliesOptions(state)
  );

  const handleProductFamilyChange = () => (
    productFamilyOptionsSelected: Array<{ label: string; value: string }>
  ) => {
    const productFamilies = productFamilyOptionsSelected.map(
      (productFamilyOption) => productFamilyOption.value
    );
    onChange(productFamilies);
  };

  return (
    <>
      {productFamiliesOptions.length ? (
        <Box marginTop={1}>
          <Autocomplete
            disabled={disabled}
            options={productFamiliesOptions.map((family: string) => ({
              label: family,
              value: family,
            }))}
            onChange={handleProductFamilyChange()}
            value={productTypeFilter.productFamilies.map((family) => ({
              label: family,
              value: family,
            }))}
            label="Produktfamilie"
            placeholder="Bitte auswählen..."
          />
        </Box>
      ) : (
        <></>
      )}
    </>
  );
};

export default ProductFamilyFilter;



// WEBPACK FOOTER //
// ./src/components/Filters/ProductTypeFilter/ProductFamilyFilter.tsx